import { FileAnswerType } from "@/types";

interface IMaxFilesExceededToastParams {
  maxFiles: number;
  maxFileSizeMB: number;
  answerType?: FileAnswerType;
}

// Non-breaking space keeps a number and its unit (e.g. "10 MB") on the same line.
const NBSP = String.fromCharCode(0xa0);

export const getMaxFilesExceededToastMessage = ({
  answerType,
  maxFiles,
  maxFileSizeMB,
}: IMaxFilesExceededToastParams): string => {
  const formats = answerType === "pdf_image" ? "PDF, JPG, or PNG" : "JPG, PNG";
  const limit =
    maxFiles === 1
      ? `Max 1 file, ${maxFileSizeMB}${NBSP}MB.`
      : `Up to ${maxFiles} files, ${maxFileSizeMB}${NBSP}MB each.`;

  return `Accepted: ${formats}. ${limit}`;
};
